import { ConsentString } from 'consent-string';
import { loadGdprAdConsentString } from 'owa-gdpr-ad-consent-string';
import { lazyAdCmpInitialization } from 'owa-mail-ads-cmp';

export interface GdprDataPoint {
    gdprConsentDataString: string;
    consentStringPurpose: number[];
}

export async function loadGdprCmp(): Promise<GdprDataPoint> {
    // If the gdpr feature is enabled, import the ConsentManagementPlatform file to allow ast.js to check
    // Even if the user is not in EU, we need pass gdprApplies as false to cmp to AST
    await lazyAdCmpInitialization.importAndExecute();
    let consentStringPurpose = [-1];
    let gdprConsentDataString = await loadGdprAdConsentString();
    if (gdprConsentDataString?.length > 0) {
        const consentDataEncodedString = new ConsentString(gdprConsentDataString);
        consentStringPurpose = consentDataEncodedString.getPurposesAllowed();
        if (consentStringPurpose == null || consentStringPurpose.length == 0) {
            // Set consent string purpose to 0 to be easier logging
            consentStringPurpose = [0];
        }
    }

    let gdprdataPoint = {
        gdprConsentDataString: gdprConsentDataString,
        consentStringPurpose: consentStringPurpose,
    };
    return Promise.resolve(gdprdataPoint);
}
